import React, {useLayoutEffect, useRef} from 'react';
import Cart from "modules/cart.mjs";

export default function Shop({selected, open}) {
	const shopRef = useRef(null);
	let productTilesHTML = '';
	Object.entries(selected).forEach(([id, selection], index) => {
		if (selection && selection.item)  {
			productTilesHTML += selection.shop;
		}
	});

	const AddToCartEvent = (event) => {
		window.dataLayer.push({
			"event": "mix_and_match",
			"event_category": "add to cart",
			"event_label": event.target.dataset.web_id
		});
	}

	const ViewPdpEvent = (event) => {
		window.dataLayer.push({
			"event": "mix_and_match",
			"event_category": "view PDP",
			"event_label": event.target.href || event.target.offsetParent.querySelector('a.product-photo-link').href
		});
	}

	useLayoutEffect(() => {
		if (open) {
			Cart.get(true).then(cart => {
				const cartItems = cart.items;
				shopRef.current.querySelectorAll('.product-photo').forEach(product => {
					const pdpLink = product.querySelector('a.product-photo-link');
					const addToCartButton = product.querySelector('.add-to-cart');
					pdpLink.addEventListener('click', ViewPdpEvent);
					addToCartButton.dataset.postAddAction = 'none';
					addToCartButton.addEventListener('click', AddToCartEvent);
					cartItems.forEach(cartItem => {
						if (cartItem.item && cartItem.item.web_id === parseInt(addToCartButton.dataset.web_id)) {
							const selector = addToCartButton.previousElementSibling;
							selector.querySelectorAll('option').forEach(option => {
								if (parseInt(option.value) === cartItem.quantity) {
									option.selected = true;
									addToCartButton.classList.add('add_to_cart_button_highlight');
									addToCartButton.textContent = 'Added';
									addToCartButton.insertAdjacentHTML('afterbegin',
										'<span class="iconfont icon-checkmark me-1"></span>');
								}
							});
						}
					});
				});
			});
		}

		return () => {
			shopRef.current.querySelectorAll('.add-to-cart').forEach(addToCartButton => {
				addToCartButton.removeEventListener('click', AddToCartEvent);
			});
			shopRef.current.querySelectorAll('a.product-photo-link').forEach(pdpLink => {
				pdpLink.removeEventListener('click', ViewPdpEvent);
			})
		}
	});

	return (
		<div id="product-tiles" ref={shopRef} className="d-flex mx-auto" dangerouslySetInnerHTML={{__html: productTilesHTML}}></div>
	)
}